import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import DatePicker from 'react-datepicker';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { getMAEAA020, postMAEAA020, putMAEAA020 } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_BANNERS, MESSAGE } from '../../../shared/constants/app';
import { getImageSrc, getImgFolder } from '../../../utils';

const MAEAA020 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();

    const location = useLocation();
    const { id } = useParams();
    const [data, setData] = useState({
        useYN: 'Y',
    });
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('MAIN');
    const [selectedOptionTwo, setSelectedOptionTwo] = useState('MAIN');
    const [fileData, setFileData] = useState({});
    const fileInputRef = useRef(null);
    const [day, setDay] = useState(0);
    const [backgroundColor, setBackgroundColor] = useState('#ffffff');
    const [isEyedropperSupported, setIsEyedropperSupported] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if ('EyeDropper' in window) {
            setIsEyedropperSupported(true);
        }
    }, []);

    const handleEyedropperClick = () => {
        if (!isEyedropperSupported) {
            alert('Eyedropper tool is not supported in your browser.');
            return;
        }

        const eyeDropper = new window.EyeDropper();

        eyeDropper
            .open()
            .then((result) => {
                setBackgroundColor(result.sRGBHex);
            })
            .catch((error) => {
                console.error('Error selecting color:', error);
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        const fieldName = e.target.id;

        if (selectedFile) {
            const previewUrl = URL.createObjectURL(selectedFile);
            setFileData((prev) => ({
                ...prev,
                [fieldName]: {
                    name: selectedFile.name,
                    preview: previewUrl,
                    file: selectedFile,
                },
            }));
        }
    };

    const handleDateChange = (date, name) => {
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    const handleChangeOption = (e) => {
        const { name, value } = e.target;

        if (name === 'adType1') {
            setSelectedOption(value);
        } else if (name === 'adType2') {
            setSelectedOptionTwo(value);
        } else if (name === 'useYN') {
            setData((prev) => ({ ...prev, useYN: value }));
        } else if (name === 'defaultYN') {
            setData((prev) => ({ ...prev, defaultYN: value }));
        }
    };

    const handleChangeBackgroundColor = (e) => {
        setBackgroundColor(e.target.value);
    };

    const getSecondSelectOptions = () => {
        switch (selectedOption) {
            case 'MAIN':
                return [
                    { value: 'MAIN', text: '메인' },
                    { value: 'MAINTOP', text: '메인 TOP 배너' },
                    { value: 'GRAND', text: '그랜드 배너' },
                    { value: 'GRANDSUB', text: '그랜드 서브 배너' },
                    { value: 'PREMIUM', text: '프리미엄 배너' },
                    { value: 'CORP', text: '기업 배너' },
                    { value: 'MAINRESUME', text: 'HOT 인재 배너' },
                ];
            case 'SUB':
                return [
                    { value: 'RECRUIT', text: '채용소식 줄 배너' },
                    { value: 'RESUME', text: '인재소식 줄 배너' },
                    { value: 'LNB', text: '좌측 LNB 하단 배너' },
                ];
            case 'ETC':
                return [
                    { value: 'LOGIN', text: '로그인 배너' },
                    { value: 'QUICK', text: '우측 퀵 배너' },
                ];
            default:
                return [];
        }
    };

    const getBannerSize = (type) => {
        const sizeMap = {
            MAINTOP: '987 * 86',
            MAIN: '968 * 217',
            GRAND: '271 * 440',
            GRANDSUB: '234 * 325',
            PREMIUM: '214 * 185',
            CORP: '566 * 140',
            MAINRESUME: '217 * 112',
            RECRUIT: '1152 * 144',
            RESUME: '1152 * 144',
            LNB: '230 * 182',
            LOGIN: '405 * 214',
            QUICK: '120 * 230',
        };
        return sizeMap[type] || '';
    };

    const getBannerSizeMobile = (type) => {
        const sizeMap = {
            MAINTOP: '987 * 86',
            MAIN: '392 * 196',
            GRAND: '197 * 432',
            GRANDSUB: '272 * 490',
            PREMIUM: '199 * 180',
            CORP: '566 * 140',
            MAINRESUME: '197 * 114',
            RECRUIT: '410 * 51',
            RESUME: '410 * 51',
            LNB: '230 * 182',
            LOGIN: '270 * 270',
            QUICK: '120 * 230',
        };
        return sizeMap[type] || '';
    };

    const handleSave = () => {
        if (!data.title) {
            window.alert('진행기간 입력해 주세요.');
            return;
        }

        if (!fileData.imageFileMain || !fileData.imgNameAppMain320px) {
            window.alert('이미지 입력해 주세요.');
            return;
        }

        if (selectedOptionTwo === 'MAINTOP' && !fileData.imgNameAppMain640px && !fileData.imgNameAppMain960px) {
            window.alert('이미지 입력해 주세요.');
            return;
        }

        if (!data.linkType) {
            window.alert('linkType 입력해 주세요.');
            return;
        }

        if (!data.linkWinName && !data.linkUrl) {
            window.alert('url 입력해 주세요.');
            return;
        }

        if (!data.linkTypeApp) {
            window.alert('linkTypeApp 입력해 주세요.');
            return;
        }

        if (!data.linkUrlApp) {
            window.alert('url 입력해 주세요.');
            return;
        }

        if (!startDate || !endDate) {
            window.alert('진행기간 입력해 주세요.');
            return;
        }

        const isConfirmed = id ? window.confirm(MESSAGE.confirm.update) : window.confirm(MESSAGE.confirm.create);
        const message = id ? MESSAGE.notify.updateSuccess : MESSAGE.notify.createSuccess;

        let startDateFormated;
        if (selectedOptionTwo === 'MAINTOP') {
            startDateFormated = startDate ? moment(startDate).format('YYYY-MM-DD HH:mm:ss') : null;
        } else {
            startDateFormated = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        }

        let endDateFormated;
        if (selectedOptionTwo === 'MAINTOP') {
            endDateFormated = endDate ? moment(endDate).format('YYYY-MM-DD HH:mm:ss') : null;
        } else {
            endDateFormated = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        }

        const payload = {
            adType: selectedOptionTwo || 'MAIN',
            position: '',
            title: data?.title,
            imgNameMain: fileData.imageFileMain?.name || '',
            linkType: data?.linkType,
            linkWinName: data?.linkWinName || '',
            linkUrlApp: data?.linkUrlApp || '',
            imgNameAppMain320px: fileData.imgNameAppMain320px.name || '',
            imgNameAppMain640px: selectedOptionTwo === 'MAINTOP' ? fileData.imgNameAppMain640px.name : '',
            imgNameAppMain960px: selectedOptionTwo === 'MAINTOP' ? fileData.imgNameAppMain960px.name : '',
            linkTypeApp: data?.linkTypeApp,
            startDate: startDateFormated,
            adPosition: data?.adPosition || 0,
            useYn: data?.useYN || 'N',
            endDate: endDateFormated,
            linkUrl: data?.linkUrl || '',
            defaultYN: data?.defaultYN || 'Y',
            isEnd: 'N',
            visitedCnt: data?.visitedCnt || 0,
            backgroundColor: backgroundColor || '',
        };
        const formData = new FormData();
        if (id) payload.seq = id;

        if (!id) payload.imgNameSub = fileData.imageFileMain?.name || '';
        if (!id) payload.imgNameAppSub = fileData.imgNameAppSub?.name || '';
        if (!id) payload.visitedCnt = 0;

        formData.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));

        if (fileData) {
            formData.append('logo_web', fileData.imageFileMain.file);
            formData.append('logo_app_320px', fileData.imgNameAppMain320px.file);
            if (selectedOptionTwo === 'MAINTOP') {
                formData.append('logo_app_640px', fileData.imgNameAppMain640px.file);
                formData.append('logo_app_960px', fileData.imgNameAppMain960px.file);
            }
        }

        if (isConfirmed) {
            if (id) {
                putMAEAA020(formData)
                    .then(() => {
                        window.alert(message);
                        navigate(`/maeaa010${location.search}`);
                    })
                    .catch((error) => console.log(error));
            } else {
                postMAEAA020(formData)
                    .then(() => {
                        window.alert(message);
                        navigate(`/maeaa010${location.search}`);
                    })
                    .catch((error) => console.log(error));
            }
        }
    };

    useEffect(() => {
        if (id) {
            getMAEAA020(id)
                .then(({ data }) => {
                    setData(data);
                    if (data?.startDate && data?.endDate) {
                        const start = moment(data?.startDate);
                        const end = moment(data?.endDate);
                        const day = end.diff(start, 'day');
                        setDay(day);
                    }
                    setFileData({
                        imageFileMain: {
                            name: data?.imgNameMain,
                            preview: getImageSrc(getImgFolder(data?.adType), data?.imgNameMain),
                        },
                        imgNameAppMain320px: {
                            name: data?.imgNameAppMain320px,
                            preview: getImageSrc(getImgFolder(data?.adType), data?.imgNameAppMain320px),
                        },
                        imgNameAppMain640px: {
                            name: data?.imgNameAppMain640px,
                            preview: getImageSrc(getImgFolder(data?.adType), data?.imgNameAppMain640px),
                        },
                        imgNameAppMain960px: {
                            name: data?.imgNameAppMain960px,
                            preview: getImageSrc(getImgFolder(data?.adType), data?.imgNameAppMain960px),
                        },
                    });

                    setStartDate(data?.startDate);
                    setEndDate(data?.endDate);
                    if (data?.backgroundColor !== null) setBackgroundColor(data?.backgroundColor);
                })
                .catch((error) => console.log(error));
        }
    }, [id]);

    useEffect(() => {
        if (data?.adType) {
            const adType = data.adType;

            console.log('adType', adType);

            if (['MAIN', 'MAINTOP', 'GRAND', 'GRANDSUB', 'PREMIUM', 'MAINRESUME', 'CORP'].includes(adType)) {
                setSelectedOption('MAIN');
            } else if (['RECRUIT', 'RESUME', 'LNB'].includes(adType)) {
                setSelectedOption('SUB');
            } else if (['LOGIN', 'QUICK'].includes(adType)) {
                setSelectedOption('ETC');
            } else {
                setSelectedOption('MAIN');
            }
            setSelectedOptionTwo(adType);
        }
    }, [data]);

    useEffect(() => {
        const secondOptions = getSecondSelectOptions(selectedOption);

        if (secondOptions.length > 0) {
            const firstValue = secondOptions[0].value;

            setSelectedOptionTwo(firstValue);

            handleChangeOption({
                target: {
                    name: 'adType2',
                    value: firstValue,
                },
            });
        }
    }, [selectedOption]);


    useEffect(() => {
        if (startDate && endDate) {
            const start = moment(startDate);
            const end = moment(endDate);
            const diff = end.diff(start, 'days');
            setDay(diff);
        }
    }, [startDate, endDate]);
    return (
        <div className="container">
            <div className="wrap content">
                <SideMenu menu={MENU_BANNERS} />
                <div className="manager-banner-content-change-content content-right">
                    <div id="manager-banner-content-change-content-list">
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th className="require" colSpan={2}>
                                        <span>구분 선택</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="select-box d-flex gap-2" style={{ alignItems: 'center' }}>
                                            <select name="adType1" onChange={handleChangeOption} value={selectedOption}>
                                                <option value="MAIN">메인</option>
                                                <option value="SUB">서브</option>
                                                <option value="ETC">기타</option>
                                            </select>
                                            <select
                                                name="adType2"
                                                onChange={handleChangeOption}
                                                value={selectedOptionTwo}
                                            >
                                                {getSecondSelectOptions(selectedOption).map((option, index) => (
                                                    <option key={`${option.value}-${index}`} value={option.value}>
                                                        {option.text}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <th className="require" colSpan={2}>
                                        <span>배너명</span>
                                    </th>
                                    <td colSpan={3}>
                                        <input
                                            type="text"
                                            onChange={handleChange}
                                            name="title"
                                            placeholder="배너명 입력"
                                            value={data?.title || ''}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={5}>
                                        <span>배너 등록</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th rowSpan={2}>
                                        <span>웹</span>
                                    </th>
                                    <th className="require">
                                        <span>이미지</span>
                                        {selectedOptionTwo ? (
                                            <div style={{ fontSize: '12px' }}>
                                                (사이즈: {getBannerSize(selectedOptionTwo)} 픽셀)
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </th>
                                    <td colSpan={3}>
                                        <div className="group-input">
                                            <input
                                                type="file"
                                                className="file-input"
                                                id="imageFileMain"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                                ref={fileInputRef}
                                            />
                                            <label htmlFor="imageFileMain">파일 선택</label>
                                            <input type="text" readOnly value={fileData.imageFileMain?.name || ''} />
                                        </div>
                                        <div className="preview-image">
                                            {fileData.imageFileMain?.preview && (
                                                <img
                                                    src={fileData.imageFileMain.preview}
                                                    alt="Preview"
                                                    className="resume__image"
                                                />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className="require">
                                        <span>url</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="select-box">
                                            <select onChange={handleChange} name="linkType" value={data?.linkType}>
                                                <option value="">Link type 선택</option>
                                                <option value="_self">화면 전환</option>
                                                <option value="_blank">새창 화면</option>
                                                <option value="window">팝업창</option>
                                            </select>
                                            <input
                                                type="text"
                                                placeholder="팝업장명"
                                                onChange={handleChange}
                                                name="linkWinName"
                                                disabled={data?.linkType !== 'window'}
                                                value={data?.linkType === 'window' ? data?.linkWinName : ''}
                                            />
                                            <input
                                                type="text"
                                                placeholder="링크 등록"
                                                onChange={handleChange}
                                                name="linkUrl"
                                                value={data?.linkUrl || ''}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th rowSpan={2}>
                                        <span>모바일</span>
                                    </th>
                                    <th className="require">
                                        <span>이미지</span>
                                        {selectedOptionTwo ? (
                                            <div style={{ fontSize: '12px' }}>
                                                (사이즈:{' '}
                                                {getBannerSizeMobile(selectedOptionTwo)
                                                    ? getBannerSizeMobile(selectedOptionTwo)
                                                    : getBannerSize(selectedOptionTwo)}{' '}
                                                픽셀)
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </th>
                                    <td colSpan={3}>
                                        <div className="group-input">
                                            <input
                                                type="file"
                                                className="file-input"
                                                id="imgNameAppMain320px"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                                ref={fileInputRef}
                                            />
                                            <label htmlFor="imgNameAppMain320px">
                                                파일 선택 {selectedOptionTwo === 'MAINTOP' && '(320px)'}
                                            </label>
                                            <input
                                                type="text"
                                                readOnly
                                                value={fileData.imgNameAppMain320px?.name || ''}
                                            />
                                        </div>
                                        {selectedOptionTwo === 'MAINTOP' && (
                                            <>
                                                <div className="group-input" style={{ marginTop: '10px' }}>
                                                    <input
                                                        type="file"
                                                        className="file-input"
                                                        id="imgNameAppMain640px"
                                                        accept="image/*"
                                                        onChange={handleFileChange}
                                                        ref={fileInputRef}
                                                    />
                                                    <label htmlFor="imgNameAppMain640px">파일 선택 (640px)</label>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={fileData.imgNameAppMain640px?.name || ''}
                                                    />
                                                </div>
                                                <div className="group-input" style={{ marginTop: '10px' }}>
                                                    <input
                                                        type="file"
                                                        className="file-input"
                                                        id="imgNameAppMain960px"
                                                        accept="image/*"
                                                        onChange={handleFileChange}
                                                        ref={fileInputRef}
                                                    />
                                                    <label htmlFor="imgNameAppMain960px">파일 선택 (960px)</label>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={fileData.imgNameAppMain960px?.name || ''}
                                                    />
                                                </div>
                                            </>
                                        )}

                                        <div className="preview-image">
                                            {fileData.imgNameAppMain320px?.preview && (
                                                <img
                                                    src={fileData.imgNameAppMain320px.preview}
                                                    alt="Preview"
                                                    className="resume__image"
                                                />
                                            )}
                                            {selectedOptionTwo === 'MAINTOP' && (
                                                <>
                                                    {fileData.imgNameAppMain640px?.preview && (
                                                        <img
                                                            src={fileData.imgNameAppMain640px.preview}
                                                            alt="Preview"
                                                            className="resume__image"
                                                        />
                                                    )}
                                                    {fileData.imgNameAppMain960px?.preview && (
                                                        <img
                                                            src={fileData.imgNameAppMain960px.preview}
                                                            alt="Preview"
                                                            className="resume__image"
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </div>
                                        {selectedOptionTwo === 'MAINTOP' && (
                                            <div className="color-picker">
                                                <HexColorPicker color={backgroundColor} onChange={setBackgroundColor} />
                                                <div className="d-flex align-items-center mt-3">
                                                    <button className="btn" onClick={handleEyedropperClick}>
                                                        <i className="icon icon-eye-dropper"></i>
                                                    </button>
                                                    <p>
                                                        선택된 컬러:{' '}
                                                        <input
                                                            style={{ width: '105px' }}
                                                            type="text"
                                                            value={backgroundColor || '#ffffff'}
                                                            onChange={handleChangeBackgroundColor}
                                                        />
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th className="require">
                                        <span>url</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="select-box">
                                            <select
                                                onChange={handleChange}
                                                name="linkTypeApp"
                                                value={data?.linkTypeApp}
                                            >
                                                <option value="">Link type 선택</option>
                                                <option value="_self">페이지(_self)</option>
                                                <option value="_blank">페이지 (_blank, 새창)</option>
                                                <option value="window">팝업창</option>
                                            </select>
                                            <input
                                                type="text"
                                                placeholder="링크 등록"
                                                onChange={handleChange}
                                                name="linkUrlApp"
                                                value={data?.linkUrlApp || ''}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className="require" colSpan={2}>
                                        <span>진행기간</span>
                                    </th>
                                    {selectedOptionTwo === 'MAINTOP' ? (
                                        <td>
                                            <div className="flex group-item">
                                                <div className="group-datepicker">
                                                    <div className="datepicker-child w200">
                                                        <DatePicker
                                                            ref={startDateRef}
                                                            onChange={(date) => handleDateChange(date, 'startDate')}
                                                            locale={'ko'}
                                                            placeholderText={'YYYY/MM/DD HH:mm'}
                                                            dateFormat={'yyyy/MM/dd HH:mm'}
                                                            selected={startDate}
                                                            timeInputLabel="시간:"
                                                            showTimeInput
                                                            maxDate={endDate || null}
                                                        />
                                                        <i
                                                            className="icon icon-date"
                                                            id="start-date-icon"
                                                            onClick={() => startDateRef.current.setFocus()}
                                                        />
                                                    </div>
                                                    <span>~</span>
                                                    <div className="datepicker-child w200">
                                                        <DatePicker
                                                            ref={endDateRef}
                                                            onChange={(date) => handleDateChange(date, 'endDate')}
                                                            locale={'ko'}
                                                            placeholderText={'YYYY/MM/DD HH:mm'}
                                                            dateFormat={'yyyy/MM/dd HH:mm'}
                                                            timeInputLabel="시간:"
                                                            showTimeInput
                                                            selected={endDate}
                                                            minDate={startDate || null}
                                                        />
                                                        <i
                                                            className="icon icon-date"
                                                            id="end-date-icon"
                                                            onClick={() => endDateRef.current.setFocus()}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    ) : (
                                        <td>
                                            <div className="flex group-item">
                                                <div className="group-datepicker">
                                                    <div className="datepicker-child">
                                                        <DatePicker
                                                            ref={startDateRef}
                                                            onChange={(date) => handleDateChange(date, 'startDate')}
                                                            locale={'ko'}
                                                            placeholderText={'YYYY/MM/DD'}
                                                            dateFormat={'yyyy/MM/dd'}
                                                            selected={startDate}
                                                            maxDate={endDate || null}
                                                        />
                                                        <i
                                                            className="icon icon-date"
                                                            id="start-date-icon"
                                                            onClick={() => startDateRef.current.setFocus()}
                                                        />
                                                    </div>
                                                    <span>~</span>
                                                    <div className="datepicker-child">
                                                        <DatePicker
                                                            ref={endDateRef}
                                                            onChange={(date) => handleDateChange(date, 'endDate')}
                                                            locale={'ko'}
                                                            placeholderText={'YYYY/MM/DD'}
                                                            dateFormat={'yyyy/MM/dd'}
                                                            selected={endDate}
                                                            minDate={startDate || null}
                                                        />
                                                        <i
                                                            className="icon icon-date"
                                                            id="end-date-icon"
                                                            onClick={() => endDateRef.current.setFocus()}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    )}

                                    <th>
                                        <span>진행기간</span>
                                    </th>
                                    <td>{day}</td>
                                </tr>
                                <tr>
                                    <th colSpan={2}>
                                        <span>노출 순서</span>
                                    </th>
                                    <td>
                                        <div className="group-input-column">
                                            <input
                                                type="number"
                                                placeholder="배너 순서 입력"
                                                onChange={handleChange}
                                                name="adPosition"
                                                value={data?.adPosition || ''}
                                            />
                                            <span>*메인화면 리스트에서 보여질 순서입니다.</span>
                                        </div>
                                    </td>
                                    <th className="require border-b-ddd">
                                        <span>공개여부</span>
                                    </th>
                                    <td>
                                        <fieldset id="useYN" className="radio-group">
                                            <div className="item-radioBox">
                                                <input
                                                    type="radio"
                                                    name="useYN"
                                                    value="Y"
                                                    id="UseY"
                                                    checked={data.useYN === 'Y'}
                                                    onChange={handleChangeOption}
                                                />
                                                <span />
                                                <label htmlFor="UseY">
                                                    <span>공개</span>
                                                </label>
                                            </div>
                                            <div className="item-radioBox">
                                                <input
                                                    type="radio"
                                                    name="useYN"
                                                    value="N"
                                                    id="UseN"
                                                    checked={data.useYN === 'N'}
                                                    onChange={handleChangeOption}
                                                />
                                                <span />
                                                <label htmlFor="UseN">
                                                    <span>비공개</span>
                                                </label>
                                            </div>
                                        </fieldset>
                                    </td>
                                </tr>
                                {/* <tr>
                                    <th colSpan={2}>
                                        <span>위치</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="group-columns">
                                            <table className="table-gray">
                                                <tbody>
                                                    <tr>
                                                        <td>노출</td>
                                                        <td>1</td>
                                                        <td>2</td>
                                                        <td>3</td>
                                                    </tr>
                                                    <tr>
                                                        <td>노출</td>
                                                        <td>4</td>
                                                        <td>5</td>
                                                        <td>6</td>
                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td>8</td>
                                                        <td>9</td>
                                                        <td>10</td>
                                                    </tr>
                                                    <tr>
                                                        <td>11</td>
                                                        <td>12</td>
                                                        <td colSpan={2}>...</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div className="right-table group-input-column">
                                                <input
                                                    type="text"
                                                    placeholder="위치 입력"
                                                    name="position"
                                                    value={data?.position || ''}
                                                    onChange={handleChange}
                                                />
                                                <span className="note">
                                                    ※ 메인화면 프리미엄 배너리스트에서 보여질 위치입니다. 하기 순서를
                                                    참고하시고 등록하세요.
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                </tr> */}
                                <tr>
                                    <th colSpan={2}>
                                        <span>기본배너 사용여부</span>
                                    </th>
                                    <td colSpan={3}>
                                        <fieldset id="UseYn" className="radio-group">
                                            <div className="item-checkBox">
                                                <input
                                                    className="checkboxDefaultYN"
                                                    type="radio"
                                                    name="defaultYN"
                                                    value="N"
                                                    id="defaultN"
                                                    checked={data?.defaultYN === 'N'}
                                                    onChange={handleChangeOption}
                                                />
                                                <span></span>
                                                <label htmlFor="defaultN" style={{ paddingLeft: '25px' }}>
                                                    <span>사용안함</span>
                                                </label>
                                            </div>
                                            <div className="item-checkBox">
                                                <input
                                                    className="checkboxDefaultYN"
                                                    type="radio"
                                                    name="defaultYN"
                                                    value="Y"
                                                    id="defaultY"
                                                    checked={data?.defaultYN === 'Y'}
                                                    onChange={handleChangeOption}
                                                />
                                                <span></span>
                                                <label htmlFor="defaultY" style={{ paddingLeft: '25px' }}>
                                                    <span>사용함</span>
                                                </label>
                                            </div>
                                        </fieldset>
                                        <span className="note">
                                            *진행 중인 배너가 없을 경우 메인화면에 기본으로 노출되는 배너를 지정합니다.
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="bottom-content">
                            <Link
                                to={{
                                    pathname: '/maeaa010',
                                    search: location.search,
                                }}
                                className="button-back-to-list"
                            >
                                목록
                            </Link>
                            <Link className="button-save" onClick={handleSave}>
                                저장
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MAEAA020;
